import {
  Bestellung,
  BestellungFiliale,
  AbholungStatus,
  LieferungStatus,
  Terminart,
  BestellungQueryRequest,
  RemoteResult,
  BestellungList,
} from "mangdto"
import RestPaths from "@/util/rest_paths"
import store from "@/store"
import router from "@/router"
import RouteNames from "@/util/route_names"
import Poster from "@/util/poster"
import BaseLogic from "./base_logic"
import { EnumFormatter } from "mangutil"

export default class AbgeschlosseneBestellungenLogic extends BaseLogic {
  bestellungen: Bestellung[] = []
  loadWorking: boolean = false
  loadError: boolean = false
  loadCompleted: boolean = false

  formatiereLieferungStatus(bestellung: Bestellung): string {
    return EnumFormatter.formatLieferungStatus(
      bestellung.lieferung.lieferungStatus,
    )
  }

  formatiereAbholungStatus(bestellung: Bestellung): string {
    return EnumFormatter.formatAbholungStatus(bestellung.abholung.status)
  }

  formatTerminart(value: Terminart): string {
    return EnumFormatter.formatTerminart(value)
  }

  bestimmeBild(filiale: BestellungFiliale) {
    if (filiale.bildId != null) {
      return RestPaths.urlBase + RestPaths.imageImage + "/" + filiale.bildId
    }
  }

  detailsAnzeigen(bestellung: Bestellung) {
    router.push({
      name: RouteNames.BESTELLUNG_PAGE.DETAILS,
      params: { bestellungId: bestellung.id },
    })
  }

  init() {
    this.loadWorking = true
    this.loadCompleted = false
    this.loadError = false

    var request = new BestellungQueryRequest()
    request.abgeschlossen = true
    request.identifier = store.state.user.identifier

    Poster.postUser<RemoteResult<BestellungList>>(
      RestPaths.bestellungKundeListe,
      request,
    )
      .then((response) => {
        this.loadWorking = false
        if (response.data.success) {
          this.loadCompleted = true
          this.bestellungen = response.data.payload.list
        } else {
          this.loadError = true
        }
      })
      .catch(() => {
        this.loadWorking = false
        this.loadError = true
      })
  }
}
